import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import history from './history';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const router = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

// NOTE: Do not change middleares delaration pattern since rekit plugins may register middlewares to it.
const middlewares = [
  thunk,
  router,
  sagaMiddleware
];

/* istanbul ignore if  */
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_REDUX_LOGGER !== 'false') {
  const { createLogger } = require('redux-logger');

  const logger = createLogger({ collapsed: true });
  middlewares.push(logger);
}

export default function configureStore(initialState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = {
    ...createStore(rootReducer, initialState, composeEnhancers(
      applyMiddleware(...middlewares))),
    runSaga: sagaMiddleware.run(rootSaga)
  }

  /* istanbul ignore if  */
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default; // eslint-disable-line
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
